import React, { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Drawer,
  Form,
  Input,
  notification,
  DatePicker
} from 'antd'
import { useDispatch } from 'react-redux'
import { addFollowupFxn, followupListFxn } from '../actions/scheduleMeeting'
import InputBox from '../../../components/_utils/InputBox'
import { longDisplayDate } from '../../../components/_utils/appUtils'

const dateFormat = 'DD/MM/YYYY'
const { TextArea } = Input

const AddFollowup = props => {
  const { meetingId, visible, onClose } = props
  const dispatch = useDispatch()
  const [content, setContent] = useState('')
  const [date, setDate] = useState('')
  const [followupHistory, setFollowupHistory] = useState([])

  useEffect(() => {
    apiRequest()

  }, [])

  const apiRequest = async () => {
    try {
      let obj = {
        sortField: '_id',
        sortOrder: 'descend',
        meetingId: meetingId, results: 100, count: 100
      }
      const { data } = await dispatch(followupListFxn(obj))
      setFollowupHistory(data)
    } catch (error) {
      console.error('Error fetching note history:', error)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!date || !content) {
      notification.warning({
        message: 'Field are required'
      })
      return
    } else {
      const obj = {
        meetingId: meetingId,
        date: date,
        content: content
      }

      try {
        await dispatch(addFollowupFxn(obj))
        notification.success({
          message: 'Followup Added successfully'
        })
        setDate('')
        setContent('')
        apiRequest()
      } catch (err) {
        console.log(err)
      }

    }
  }

  return (
    <Drawer
      width={700}
      title='Add Follow up'
      placement='right'
      visible={visible}
      onClose={onClose}>
      <div className='form-box'>
        <div className='card unizportal' style={{ padding: 20 }}>
          <InputBox title={'Message'}>
            <TextArea
              rows={4}
              value={content}
              onChange={e => setContent(e.target.value)}
              placeholder='Enter your followup here'
            />
          </InputBox>
          <InputBox title={'Follow up Date'}>
            <DatePicker
              format={dateFormat}
              placeholder={'Follow Up Date'}
              onChange={value => {
                setDate(value)
              }}
            />
          </InputBox>
          <button className='btn mt5' type='submit' onClick={handleSubmit}>save
          </button>
        </div>

        <div className='card' style={{ padding: 20 }}>
          <h5 className={'font14_1'}>
            FollowUps List
          </h5>
          {followupHistory.map((item, index) => (
            <Card size={'small'}
                  key={index}
                  className='note-card mt0'>
              <div className='header-note mb-0'>
                <h6>
                  FollowUps
                </h6>
                <div className={'font12'}>
                  {longDisplayDate(item.date)}
                </div>
              </div>
              <hr className={'mb5 mt0'} />
              <p className='mt-0 mb-0'>{item.content}</p>
            </Card>
          ))}
        </div>
      </div>

    </Drawer>
  )
}

export default AddFollowup
